module.exports = __webpack_public_path__ + "img/FinancialTimes.9224ad13.jpg";